import { Grid, Stack, Typography } from "@mui/material";
import TanitaAgeFatCard from "../components/tanita/TanitaAgeFatCard";
import TanitaBasicHealthChartCard from "../components/tanita/TanitaBasicHealthChartCard";
import TanitaBasicHealthTableCard from "../components/tanita/TanitaBasicHealthTableCard";
import TanitaBodyType from "../components/tanita/TanitaBodyType";
import TanitaFatRadarCard from "../components/tanita/TanitaFatRadarCard";
import TanitaLegMuscleCard from "../components/tanita/TanitaLegMuscleCard";
import TanitaMetabolismCard from "../components/tanita/TanitaMetabolismCard";
import TanitaMuscleBalanceCard from "../components/tanita/TanitaMuscleBalanceCard";
import TanitaMuscleRadarCard from "../components/tanita/TanitaMuscleRadarCard";

export default function TanitaMC980Report({ healthData }) {
  return (
    <Stack direction="column" gap={4}>
      <Stack>
        <Typography variant="h5">詳細測量結果</Typography>

        <Grid container spacing={2}>
          <Grid item xs={12} md={6} lg={4}>
            <TanitaBasicHealthTableCard data={healthData} />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TanitaBasicHealthChartCard data={healthData} />
          </Grid>
        </Grid>
      </Stack>

      <Stack>
        <Typography variant="h5">基礎代謝/內臟脂肪指數/體水份量</Typography>

        <Grid container spacing={2}>
          <Grid item xs={12} md={6} lg={4}>
            <TanitaMetabolismCard data={healthData} />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TanitaBodyType data={healthData} />
          </Grid>
        </Grid>
      </Stack>

      <Stack>
        <Typography variant="h5">部位測量分析</Typography>

        <Grid container spacing={2}>
          <Grid item xs={12} md={6} lg={4}>
            <TanitaMuscleRadarCard data={healthData} />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TanitaFatRadarCard data={healthData} />
          </Grid>
        </Grid>
      </Stack>
      <Stack>
        <Typography variant="h5">肌肉平衡分析</Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4} lg={3}>
            <TanitaMuscleBalanceCard data={healthData} />
          </Grid>
          <Grid item xs={12} md={4} lg={3}>
            <TanitaLegMuscleCard data={healthData} />
          </Grid>
          <Grid item xs={12} md={4} lg={3}>
            <TanitaAgeFatCard data={healthData} />
          </Grid>
        </Grid>
      </Stack>
    </Stack>
  );
}
